import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'flex flex-col gap-5 sm:gap-3.5',
    options: 'flex flex-wrap gap-1'
  },
  variants: {},
  defaultVariants: {}
});
